import React from 'react';
import ReactDOM from 'react-dom';
import Main from './components/Main'
import {BrowserRouter as Router} from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/styles/style.css'

ReactDOM.render(
  <React.StrictMode>
     <Router>
       <Main/>
     </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

